import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AppStateService } from '../../app-state.service';
import { MaterialModule } from '../../material.module';
import { FormConfigService } from '../forms-config.service';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-notifications',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
  ],
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit {
  prescriptions: any[] = [];
  filteredNotifications: any[] = [];
  hasNotifications: boolean = false;
  loading = false;
  snackBar = inject(MatSnackBar);
  formConfigService = inject(FormConfigService);
  appStateService = inject(AppStateService);
  patientId: string;
  clientId: string;
  searchControl = new FormControl('');

  constructor() {
    this.clientId = this.appStateService.getState().clientId || '';
    this.patientId = this.appStateService.getState().patientId || '';
  }

  ngOnInit(): void {
    this.fetchNotificationHistory();
    this.searchControl.valueChanges.pipe(debounceTime(300)).subscribe(value => {
      this.filterMessages(value);
    });
  }

  fetchNotificationHistory(): void {
    this.loading = true;
    this.formConfigService.fetchNotifications(this.clientId, this.patientId).subscribe({
      next: (data: any) => {
        this.prescriptions = data.map((item: any) => this.formatProcedureData(item));
        this.filteredNotifications = [...this.prescriptions];
        this.hasNotifications = this.prescriptions.length > 0;
        this.loading = false;
      },
      error: (error) => {
        this.showError('Error fetching procedure history.');
        this.hasNotifications = false;
        this.loading = false;
      }
    });
  }

  formatProcedureData(data: any): any {
    return {
      date: data.date || 'Not provided',
      time: data.time || 'Not provided',
      message: data.message || 'Not provided',
    };
  }

  filterMessages(searchTerm: string | null): void {
    if (!searchTerm) {
      this.filteredNotifications = [...this.prescriptions];
    } else {
      searchTerm = searchTerm.toLowerCase();
      this.filteredNotifications = this.prescriptions.filter(message =>
        message.message.toLowerCase().includes(searchTerm) ||
        message.date.toLowerCase().includes(searchTerm) ||
        message.time.toLowerCase().includes(searchTerm)
      );
    }
  }

  showError(message: string): void {
    this.snackBar.open(message, 'Close', {
      duration: 5000,
    });
  }
}
